'use client';
import React from "react"

import Home from "./Home/index"
import CrashReloader from "../../components/CrashReloader"
import ThemeError404 from "./theme/components/404"
import Don from "./Don";
import Horaires from "./Horaires";
import Services from "./Services";
import Abonnements from "./Abonnements";
import Events from "./Events";
import Event from "./Event";
import PaiementPage from "./Paiement";
import Galeries from "./Galeries";
import GalerieImages from "./GalerieImages";
import CustomPage from "./CustomPage";
import Actu from "./Actu";
import ActuDetail from "./ActuDetail";
import LinkMetaRender from "./LinkMetaRender";
import FormPage from "./Form";
import Article from "./Article";
import ContentHubPage from "./ContentHub";
import AccountSpacePage from "./AccountSpacePage";
import EncheresPage from "./EncheresPage";
import {useTranslator} from "../../i18n";
import Page404 from "./404";
import logger from "../../services/logger"

//LEGACY COMPATIBILIY
//import 'core-js/features/array/at';

export default function ThemeUmmah({context})
{
    //console.log("ThemeUmmah",context)

    // Loader désactivé : NProgress (configuré dans _app.js) gère le feedback
    // visuel pendant les navigations sans toucher l'arbre React. Évite les
    // re-renders en cascade qui forçaient le démontage/remontage du sous-arbre.
    const loading = false;
    const [isMobile, setIsMobile] = React.useState(context.isMobile);
    const [isIframe, setIsIframe] = React.useState(false);


    React.useEffect(() =>
    {
        const _isIframe = window.self !== window.top
        setIsIframe(_isIframe)
        initMobileObserver()
    }, []);

    const initMobileObserver=()=>{
        new ResizeObserver(function() {
            const _width=document.body.offsetWidth
            const _isMobile=_width<=768
            //console.log("mobileObserver",_width,_isMobile)
            setIsMobile(_isMobile)
        }).observe(document.body);
    }

    var page=context.page

    logger.debug({ page }, "PAGE")
    logger.debug({ isMobile }, "isMobile")

    const T=useTranslator(context)

    const _context={...context,isMobile:isMobile,isIframe:isIframe,T:T}

    const PageComponent = (() => {
        switch (page.type) {
            case "HOME":             return Home;
            case "PAIEMENT":         return PaiementPage;
            case "DON":              return Don;
            case "HORAIRES":         return Horaires;
            case "SERVICES":         return Services;
            case "ABONNEMENTS":      return Abonnements;
            case "EVENTS":           return Events;
            case "EVENT":            return Event;
            case "GALERIES":         return Galeries;
            case "GALERIES_IMAGES":  return GalerieImages;
            case "ACTU":             return Actu;
            case "ACTU_DETAIL":      return ActuDetail;
            case "CUSTOM_PAGE":      return CustomPage;
            case "FORM":             return FormPage;
            case "LINK":             return LinkMetaRender;
            case "ARTICLE":          return Article;
            case "CONTENT_HUB":      return ContentHubPage;
            case "ACCOUNT":          return AccountSpacePage;
            case "ENCHERES":
            case "ENCHERES_VENTE":   return EncheresPage;
            case "404":              return Page404;
            default:                 return Page404;
        }
    })();

    return (
        <CrashReloader pageKey={page?.id || page?.type}>
            <PageComponent context={_context} loading={loading}/>
        </CrashReloader>
    );
}
